module.exports = __webpack_public_path__ + "static/media/lara-johnson.9643bbc5.jpg";